export const Montserrat_SMALL_MEDIUM =
    " text-[10px] md:text-sm font-medium font-Montserrat text-Heading_Black  ";
